import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="bg-slate-950 border-t border-slate-800 text-slate-300 pt-16 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-slate-800/80">
          {/* Brand Column */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=90,format=auto/assets/9bff8fd4-e9da-49ba-96b9-18c20ed7b396/ski-logo.jpeg"
                alt="SKI & CO TRAVEL ApS Logo"
                className="h-16 sm:h-20 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Din personlige rejsepartner til håndplukkede skirejser og uforglemmelige alpeoplevelser i Østrig, Italien, Frankrig og Norge.
            </p>
          </div>

          {/* Contact Column */}
          <div className="space-y-3">
            <h3 className="font-heading font-bold text-white text-base">
              Kontakt os
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li className="font-medium text-slate-200">
                SKI & CO TRAVEL ApS
              </li>
              <li className="flex items-start gap-2.5 text-slate-400">
                <i className="fa-solid fa-location-dot text-cyan-400 mt-1" aria-hidden="true" />
                <span>Kærmindevej 31, 6000 Kolding</span>
              </li>
              <li>
                <a
                  href="tel:+4551589452"
                  className="inline-flex items-center gap-2.5 text-slate-200 hover:text-cyan-400 transition-colors whitespace-nowrap"
                >
                  <i className="fa-solid fa-phone text-cyan-400" aria-hidden="true" />
                  <span>+45 51 58 94 52</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:claus@skiogco.dk"
                  className="inline-flex items-center gap-2.5 text-slate-200 hover:text-cyan-400 transition-colors whitespace-nowrap"
                >
                  <i className="fa-solid fa-envelope text-cyan-400" aria-hidden="true" />
                  <span>claus@skiogco.dk</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="space-y-3">
            <h3 className="font-heading font-bold text-white text-base">
              Genveje
            </h3>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>
                <Link to="/om-os" className="hover:text-cyan-400 transition-colors">
                  Om os
                </Link>
              </li>
              <li>
                <Link to="/konceptet" className="hover:text-cyan-400 transition-colors">
                  Konceptet
                </Link>
              </li>
              <li>
                <Link to="/destinationer" className="hover:text-cyan-400 transition-colors">
                  Udvalgte destinationer
                </Link>
              </li>
              <li>
                <Link to="/processen" className="hover:text-cyan-400 transition-colors">
                  Processen
                </Link>
              </li>
              <li>
                <Link to="/skirejser" className="hover:text-cyan-400 transition-colors">
                  Skirejseoversigt
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="hover:text-cyan-400 transition-colors">
                  Billedgalleri
                </Link>
              </li>
            </ul>
          </div>

          {/* Information Links */}
          <div className="space-y-3">
            <h3 className="font-heading font-bold text-white text-base">
              Information
            </h3>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>
                <Link to="/om-os" className="hover:text-cyan-400 transition-colors">
                  Om SKI & CO TRAVEL
                </Link>
              </li>
              <li>
                <Link to="/praktisk-information" className="hover:text-cyan-400 transition-colors">
                  Praktisk information
                </Link>
              </li>
              <li>
                <Link to="/betingelser" className="hover:text-cyan-400 transition-colors">
                  Betingelser og forbehold
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-cyan-400 transition-colors">
                  Send en uforpligtende forespørgsel
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom copyright line */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p>
            &copy; {new Date().getFullYear()} SKI & CO TRAVEL ApS. Alle rettigheder forbeholdes.
          </p>
          <p className="text-slate-600">
            Personlige skirejser og professionel rejserådgivning
          </p>
        </div>
      </div>
    </footer>
  )
}
